<template>
<pop-up-layout 
  :title="$t('comerciales.editarPromocionesTitle')"
  :description="$t('comerciales.editarPromocionesDescripcion', {usuario: comercialEditado.NOMBRE_ACTOR})"
  :aceptar="$t('general.misc.guardar')"
  :loading="loading"
  :saving="waitingForLoad"
  :disabled="!cambiado"
  @volver="$parent.hide()"
  @aceptar="guardar()"
>
  <v-layout wrap>
    <v-flex xs12 sm10 md5 xl4>
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('general.misc.buscar')"
      />
    </v-flex>
    <v-flex xs12 sm10 md5 xl4 :pl-2="$vuetify.breakpoint.mdAndUp">
      <v-select
        :label="$t('general.misc.promociones')"
        :items="filtro"
        v-model="filtroSeleccionadas"
      />
    </v-flex>
  </v-layout>
  <v-layout column justify-center align-center>
    <v-data-table
      v-model="selected"
      style="width:100%"
      select-all
      :headers="headers"
      :items="filtroSeleccionadas === 'todas' ?  promociones : selected"
      item-key="codigo"
      :search="search"
      :pagination.sync="pagination"
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th :class="{tableSmallPadding: $vuetify.breakpoint.xsOnly}">
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              color="primary"
              hide-details
              @click.stop="toggleAll"
            />
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              header.align ? 'text-xs-'+header.align : '',
              header.class ? header.class : '', 
              'column sortable', 
              pagination.descending ? 'desc' : 'asc', 
              header.value === pagination.sortBy ? 'active' : ''
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td :class="{tableSmallPadding: $vuetify.breakpoint.xsOnly}">
            <v-checkbox
              :input-value="props.selected"
              color="primary"
              hide-details
            />
          </td>
          <td class="text-xs-left tableSmallPadding">
            {{props.item.codigo}}
          </td>
          <td class="text-xs-left tableSmallPadding">
            {{props.item.descripcion}}
          </td>
          <td :class="{tableSmallPadding: $vuetify.breakpoint.xsOnly}">
            <v-checkbox
              :input-value="isGestorComercial(props.item)"
              color="primary"
              hide-details
              @click.stop="clickGestorComercial(props.item)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    comercialEditado: {
      type: Object
    }
  },
  data () {
    return {
      pagination: {
        sortBy: 'nombre',
        rowsPerPage: -1,
        descending: false
      },
      waitingForLoad: false,
      loading: true,
      cambiadoData: false,
      selected: [],
      promocionesGestor: [],
      search: null,
      filtroSeleccionadas: 'todas',
      guardando: false
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromociones(this.comercialEditado.ID_ACTOR)
      this.promocionesGestor = await this.loadPromocionesGestor(this.comercialEditado.ID_ACTOR)
      this.selected = this.comercialEditado.promociones.map(x => {
        return {
          descripcion: x.descripcion,
          codigo: x.codigo,
          cod_sociedad: x.cod_sociedad
        }
      })
      this.cambiadoData = false
      this.loading = false
      this.$emit('cambiado', false)
    } catch (error) {
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      promociones: 'comerciales/promociones/getAll'
    }),
    headers () {
      return [
        {
          text: this.$t('general.misc.codigo'),
          value: 'codigo',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('general.misc.descripcion'),
          value: 'descripcion',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('comerciales.gestorComercial'),
          value: 'gestorComercial',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        }
      ]
    },
    filtro () {
      return [
        { text: this.$t('general.misc.todas'), value: 'todas' },
        { text: this.$t('general.misc.seleccionadas'), value: 'seleccionadas' }
      ]
    },
    cambiado () {
      if (this.cambiadoData) {
        return true
      }
      // eslint-disable-next-line
      this.cambiadoData = this.cambiadoData || this.comercialEditado.promociones.length !== this.selected.length
      if (this.cambiadoData && !this.loading) {
        this.$emit('cambiado', true)
      }
      return this.cambiadoData
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromociones: 'comerciales/loadPromociones',
      loadPromocionesGestor: 'comerciales/loadPromocionesGestor',
      modificarPromociones: 'comerciales/modificarPromociones'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.promociones.slice()
    },
    async guardar () {
      try {
        this.guardando = true
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        let promocionesApi = []
        this.selected.forEach(p => {
          promocionesApi.push({
            COD_PROMOCION: p.codigo,
            DESC_PROMOCION: p.descripcion,
            COD_SOCIEDAD: p.cod_sociedad != null ? p.cod_sociedad : ''
          })
        })
        await this.modificarPromociones({
          id: this.comercialEditado.ID_ACTOR,
          promociones: promocionesApi,
          promocionesGestor: this.promocionesGestor
        })
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('comerciales.guardarPromociones'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    isGestorComercial (promocion) {
      return this.promocionesGestor.includes(promocion.codigo)
    },
    clickGestorComercial (promocion) {
      if (this.isGestorComercial(promocion)) {
        this.promocionesGestor = this.promocionesGestor.filter(x => x != promocion.codigo)
      } else {
        this.promocionesGestor.push(promocion.codigo)
      }
      this.cambiadoData = true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/comerciales/EditarPromocionesComercial.vue